import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button, Alert, Badge } from "react-bootstrap";
import { FaUpload, FaArrowLeft, FaFileExcel, FaCheckCircle, FaTimesCircle, FaInfoCircle } from "react-icons/fa";
import { cargaExternaApi } from "../../../services/api/cargaExternaApi";
import { homologacionExcelApi } from "../../../services/api/homologacionExcelApi";
import { comedorApi } from "../../../services/api/comedorApi";
import { lectorApi } from "../../../services/api/lectorApi";
import "react-toastify/dist/ReactToastify.css";

const CargaExternaAtenciones = () => {
  const navigate = useNavigate();
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");

  const [homologaciones, setHomologaciones] = useState([]);
  const [comedores, setComedores] = useState([]);
  const [lectores, setLectores] = useState([]);
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState(null);

  const [formData, setFormData] = useState({
    homologacion_id: "",
    id_comedor: "",
    id_lector: ""
  });

  // Cargar datos iniciales
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Cargar homologaciones activas
        const homologacionesRes = await homologacionExcelApi.getAll(true);
        setHomologaciones(homologacionesRes.data || []);

        // Cargar comedores del proyecto
        if (selectedProject?.id) {
          const comedoresRes = await comedorApi.getByProyectoRest(selectedProject.id);
          setComedores(comedoresRes.data || []);
        }

        // Cargar lectores del proyecto
        if (selectedProject?.id) {
          const lectoresRes = await lectorApi.getByProyecto(selectedProject.id);
          setLectores(lectoresRes.data || []);
        }
      } catch (error) {
        console.error("Error cargando datos:", error);
        toast.error("Error cargando datos iniciales", { position: "top-right" });
      }
    };

    fetchData();
  }, [selectedProject?.id]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (!selectedFile.name.match(/\.(xlsx|xls)$/i)) {
        toast.error("El archivo debe ser un Excel (.xlsx o .xls)", { position: "top-right" });
        return;
      }
      setFile(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error("Por favor seleccione un archivo Excel", { position: "top-right" });
      return;
    }

    if (!formData.homologacion_id) {
      toast.error("Por favor seleccione una homologación", { position: "top-right" });
      return;
    }

    if (!formData.id_comedor) {
      toast.error("Por favor seleccione un comedor", { position: "top-right" });
      return;
    }

    if (!formData.id_lector) {
      toast.error("Por favor seleccione una lectora", { position: "top-right" });
      return;
    }

    if (!selectedProject?.id) {
      toast.error("No hay proyecto seleccionado", { position: "top-right" });
      return;
    }

    setIsLoading(true);
    setResults(null);

    try {
      const response = await cargaExternaApi.procesarCargaExterna(
        file,
        parseInt(formData.homologacion_id),
        selectedProject.id,
        parseInt(formData.id_comedor),
        parseInt(formData.id_lector)
      );

      setResults(response.data);
      
      // Verificar si hay errores antes de mostrar éxito
      const stats = response.data?.stats || {};
      const hasErrors = stats.turnos_detalle_errores > 0;
      const erroresReales = stats.errores || [];
      
      if (hasErrors && erroresReales.length > 0) {
        toast.warning(
          `Carga procesada con ${erroresReales.length} error(es). Revise los resultados.`, 
          { position: "top-right" }
        );
      } else {
        toast.success("Carga externa procesada correctamente", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error procesando carga externa:", error);
      const errorMessage = error.response?.data?.detail || error.response?.data?.message || "Error al procesar la carga externa";
      toast.error(errorMessage, { position: "top-right" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          .dh-process-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          .dh-main-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
          }
          
          .dh-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
            margin-bottom: 2rem;
          }
          
          .dh-card-header {
            border-radius: 20px 20px 0 0;
            padding: 1.5rem 2rem;
            border: none;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            font-weight: 700;
          }
          
          .dh-form-control {
            border-radius: 12px;
            border: 2px solid #e5e7eb;
            padding: 12px 16px;
            transition: all 0.3s ease;
          }
          
          .dh-form-control:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          }
          
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 14px 28px;
            font-weight: 600;
            font-size: 1rem;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-primary:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 12px 20px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          .dh-badge-success {
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            color: white;
            border-radius: 10px;
            padding: 8px 16px;
            font-weight: 600;
            font-size: 0.9rem;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            margin: 0.25rem;
          }
          
          .dh-badge-info {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border-radius: 10px;
            padding: 8px 16px;
            font-weight: 600;
            font-size: 0.9rem;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            margin: 0.25rem;
          }
          
          .dh-badge-danger {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white;
            border-radius: 10px;
            padding: 8px 16px;
            font-weight: 600;
            font-size: 0.9rem;
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            margin: 0.25rem;
          }
          
          .dh-info-box {
            background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
            border-left: 4px solid #3b82f6;
            border-radius: 12px;
            padding: 1.5rem;
            margin-bottom: 1.5rem;
          }
          
          .dh-results-card {
            background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
            border-radius: 20px;
            padding: 2rem;
          }
          
          .dh-stat-item {
            background: white;
            border-radius: 12px;
            padding: 1.5rem;
            margin-bottom: 1rem;
            box-shadow: 0 4px 6px rgba(0,0,0,0.05);
            border-left: 4px solid #667eea;
          }
        `}
      </style>

      <div className="dh-process-bg">
        <ToastContainer />
        
        <div className="dh-main-header">
          <Container>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h1 className="mb-0" style={{ fontSize: '2.2rem', fontWeight: 700 }}>
                  <FaFileExcel className="me-3" />
                  Carga Externa de Atenciones
                </h1>
                <p className="mb-0 mt-2" style={{ fontSize: '1.1rem', opacity: 0.9 }}>
                  Cargar atenciones de comensales desde archivo Excel de proveedores externos
                </p>
              </div>
              <Button 
                className="btn-dh-secondary d-flex align-items-center"
                onClick={() => navigate("/home")}
              >
                <FaArrowLeft className="me-2" />
                Volver
              </Button>
            </div>
          </Container>
        </div>

        <Container>
          <Row>
            <Col lg={12}>
              <Card className="dh-card">
                <Card.Header className="dh-card-header">
                  <h4 className="mb-0">
                    <FaUpload className="me-2" />
                    Configuración de Carga
                  </h4>
                </Card.Header>
                <Card.Body style={{ padding: '2rem' }}>
                  <div className="dh-info-box">
                    <div className="d-flex align-items-start">
                      <FaInfoCircle className="me-2 mt-1" style={{ color: '#3b82f6', fontSize: '1.2rem' }} />
                      <div>
                        <strong>Instrucciones:</strong>
                        <ul className="mb-0 mt-2" style={{ fontSize: '0.9rem' }}>
                          <li>Seleccione la homologación que corresponde al formato del Excel del proveedor</li>
                          <li>Elija el comedor y lectora donde se registrarán las atenciones</li>
                          <li>Suba el archivo Excel con las atenciones</li>
                          <li>El sistema procesará automáticamente y creará los turnos correspondientes</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label style={{ fontWeight: 600, color: '#374151', marginBottom: '0.5rem' }}>
                        Homologación de Excel *
                      </Form.Label>
                      <Form.Select
                        className="dh-form-control"
                        value={formData.homologacion_id}
                        onChange={(e) => setFormData({ ...formData, homologacion_id: e.target.value })}
                        required
                      >
                        <option value="">Seleccione una homologación</option>
                        {homologaciones.map((hom) => (
                          <option key={hom.id} value={hom.id}>
                            {hom.descripcion || 'Sin descripción'}
                            {hom.detalle && ` (Cols: Fecha=${hom.detalle.columna_fecha_atencion}, Servicio=${hom.detalle.columna_tipo_servicio}, Doc=${hom.detalle.columna_numero_documento}, Formato: ${hom.detalle.formato_fecha})`}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Text className="text-muted" style={{ fontSize: '0.85rem' }}>
                        Seleccione la parametría que define las columnas del Excel del proveedor
                      </Form.Text>
                    </Form.Group>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-4">
                          <Form.Label style={{ fontWeight: 600, color: '#374151', marginBottom: '0.5rem' }}>
                            Comedor *
                          </Form.Label>
                          <Form.Select
                            className="dh-form-control"
                            value={formData.id_comedor}
                            onChange={(e) => setFormData({ ...formData, id_comedor: e.target.value })}
                            required
                          >
                            <option value="">Seleccione un comedor</option>
                            {comedores.map((comedor) => (
                              <option key={comedor.id} value={comedor.id}>
                                {comedor.nombre}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-4">
                          <Form.Label style={{ fontWeight: 600, color: '#374151', marginBottom: '0.5rem' }}>
                            Lectora *
                          </Form.Label>
                          <Form.Select
                            className="dh-form-control"
                            value={formData.id_lector}
                            onChange={(e) => setFormData({ ...formData, id_lector: e.target.value })}
                            required
                          >
                            <option value="">Seleccione una lectora</option>
                            {lectores.map((lector) => (
                              <option key={lector.id} value={lector.id}>
                                {lector.nombre}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-4">
                      <Form.Label style={{ fontWeight: 600, color: '#374151', marginBottom: '0.5rem' }}>
                        Archivo Excel *
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                        className="dh-form-control"
                        required
                      />
                      {file && (
                        <div className="mt-2">
                          <Badge bg="info" style={{ fontSize: '0.85rem', padding: '6px 12px' }}>
                            <FaFileExcel className="me-1" />
                            {file.name}
                          </Badge>
                        </div>
                      )}
                      <Form.Text className="text-muted" style={{ fontSize: '0.85rem' }}>
                        Seleccione el archivo Excel con las atenciones del proveedor (.xlsx o .xls)
                      </Form.Text>
                    </Form.Group>

                    <Button
                      type="submit"
                      className="btn-dh-primary w-100 d-flex align-items-center justify-content-center"
                      disabled={isLoading}
                      style={{ fontSize: '1.1rem', padding: '16px' }}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" />
                          Procesando...
                        </>
                      ) : (
                        <>
                          <FaUpload className="me-2" />
                          Procesar Carga Externa
                        </>
                      )}
                    </Button>
                  </Form>
                </Card.Body>
              </Card>

              {results && results.stats && (
                <Card className="dh-card" style={{ marginTop: '2rem' }}>
                  <Card.Header className="dh-card-header">
                    <h4 className="mb-0">
                      <FaCheckCircle className="me-2" />
                      Resultados de la Carga
                    </h4>
                  </Card.Header>
                  <Card.Body style={{ padding: '2rem' }}>
                    <div className="dh-results-card">
                      <div className="dh-stat-item">
                        <div style={{ fontSize: '0.9rem', color: '#6b7280', marginBottom: '0.5rem' }}>
                          Total de filas procesadas
                        </div>
                        <div style={{ fontSize: '2rem', fontWeight: 700, color: '#374151' }}>
                          {results.stats.total_filas}
                        </div>
                      </div>

                      <div className="mb-3">
                        <span className="dh-badge-success">
                          <FaCheckCircle /> Turnos Cabecera Creados: {results.stats.turnos_cabecera_creados}
                        </span>
                      </div>

                      <div className="mb-3">
                        <span className="dh-badge-info">
                          Turnos Cabecera Existentes: {results.stats.turnos_cabecera_existentes}
                        </span>
                      </div>

                      <div className="mb-3">
                        <span className="dh-badge-success">
                          <FaCheckCircle /> Turnos Detalle Creados: {results.stats.turnos_detalle_creados}
                        </span>
                      </div>

                      {results.stats.turnos_detalle_errores > 0 && (
                        <div className="mb-3">
                          <span className="dh-badge-danger">
                            <FaTimesCircle /> Errores: {results.stats.turnos_detalle_errores}
                          </span>
                        </div>
                      )}

                      {results.stats.errores && results.stats.errores.length > 0 && (
                        <Alert variant="danger" className="mt-3" style={{ borderRadius: '12px', border: 'none' }}>
                          <strong>Errores encontrados:</strong>
                          <ul className="mb-0 mt-2" style={{ fontSize: "0.85rem" }}>
                            {results.stats.errores.slice(0, 10).map((error, idx) => (
                              <li key={idx}>{error}</li>
                            ))}
                            {results.stats.errores.length > 10 && (
                              <li>... y {results.stats.errores.length - 10} errores más</li>
                            )}
                          </ul>
                        </Alert>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CargaExternaAtenciones;
